import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';

import { Group } from '../Models/group';
import { LdapConfiguration } from '../Views/Admin/ldap/ldap.component';
import { User } from '../Models/user';
import {Profile, Right} from '../Models/profile';
import { GlobalVariableGroup } from '../Models/globalVariableGroup';
import {UserSecurityConfig} from '../Models/userSecurityConfig';
import {MenuItem} from '../Models/menuItem';
import {DropDownContent} from '../Models/dropDownContent';


@Injectable({
  providedIn: 'root'
})

export class AdminService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private modalService: BsModalService) { }

  loadGroupList() {
    return this.http.get<Group[]>('/api/loadGroups');
  }

  loadUserList() {
    return this.http.post<User[]>('/api/admin/loadUsers', null);
  }

  loadDropdownContent(url: string) {
    return this.http.post<DropDownContent[]>(url, null);
  }

  loadUserById(params: any): Observable<any> {
    return this.http.post<User>('/api/admin/loadUserById', params)
      .pipe();
  }

  loadGroupById(groupId: number): Observable<any> {
    return this.http.post<Group>('api/loadGroupById', { groupId })
      .pipe();
  }

  loadGroupUsers(groupId: number): Observable<any> {
    return this.http.post<User[]>('api/loadGroupUsers', { groupId })
      .pipe();
  }

  loadProfiles() {
    return this.http.post<Profile[]>('/api/admin/loadProfiles', null);
  }

  loadGlobalVariablesGroups() {
    return this.http.post<GlobalVariableGroup[]>('/api/globalVariable/configGroup', null);
  }

  saveUser(params: any): Observable<any> {
    return this.http.post<any>('api/admin/saveUser', params )
      .pipe();
  }

  saveGroup(params: any): Observable<any> {
    return this.http.post<any>('api/saveGroup', params )
      .pipe();
  }

  getLdapConfiguration() {
    return this.http.get<LdapConfiguration>('/api/ldap/configuration');
  }

  testConnection(config: LdapConfiguration): Observable<any> {
    return this.http.post<any>('/api/ldap/testConnection', config )
      .pipe();
  }

  findGroups(config: LdapConfiguration): Observable<any> {
    return this.http.post<any>('/api/ldap/findGroups', config )
      .pipe();
  }

  getGroupAttributeNames(entries: any): Observable<any> {
    return this.http.post<any>('/api/ldap/groupAttributeNames', entries )
      .pipe();
  }

  countGroupRelatedBPInstances(groupId: number): Observable<any> {
    return this.http.post<number>('api/countGroupRelatedBPInstances', { groupId })
      .pipe();
  }


  getUserAttributeNames(requestParams: any): Observable<any> {
    return this.http.post<any>('/api/ldap/userAttributeNames', requestParams )
      .pipe();
  }

  saveLdapConfig(params: any): Observable<any> {
    return this.http.post<any>('/api/ldap/save', params )
      .pipe();
  }

  getUserSecurityConfig() {
    return this.http.get<UserSecurityConfig>('/api/userSecurityConfig/get');
  }

  udpateUserSecurityConfig(config: UserSecurityConfig): Observable<any> {
    return this.http.post<any>('/api/userSecurityConfig/update', config )
      .pipe();
  }

  getRights() {
    return this.http.get<Right[]>('/api/profile/getRights');
  }

  getAllMenuItens() {
    return this.http.get<MenuItem[]>('/api/menuItems/getAll');
  }

  saveProfile(profile: Profile, oldProfile: Profile): Observable<any> {
    return this.http.post<any>('/api/profile/save', {'profile': profile, 'oldProfile': oldProfile} )
      .pipe();
  }

  getProfile(profileId: number) {
    return this.http.post<Profile>('/api/profile/get', {profileId});
  }

  checkItemsRight(item: number) {
    return this.http.post<any>('api/rights/checkItemRights', {idMenu: item});
  }

  getUsersByGlobalVariableGroupUserFilter(filterParam: any) {
    return this.http.post<any[]>('api/user/getUsersByGlobalVariableGroupUserFilter', filterParam );
  }

  getUserByLogonName(userLogon) {
    return this.http.get<any[]>(`api/user/getUserByLogonName/${userLogon}`);
  }

  getUserFavoritePage() {
    return this.http.get<any>(`api/user/getUserFavoritePage`);
  }

}
